import db from "../db/database";
import { fetchFromBusinessCentral, fetchFromApiV2 } from "../utils/businessCentralUtils";
import { getCurrentEnvironment } from "../utils/businessCentralUtils";
import { isOnline } from "./syncService";
import { COUNTRY_CODES } from "../constants/countries";

const mapHondurasEmpresa = (data = {}) => ({
    Primary_Key: data.id || "",
    Name: data.displayName || "",
    Address: data.addressLine1 || "",
    Address_2: data.addressLine2 || "",
    City: data.city || "",
    County: data.state || "",
    Post_Code: data.postalCode || "",
    Country_Region_Code: data.country || "",
    Phone_No: data.phoneNumber || "",
    Fax_No: data.faxNumber || "",
    E_Mail: data.email || "",
    Home_Page: data.website || "",
    VAT_Registration_No: data.taxRegistrationNumber || "",
    Industrial_Classification: data.industry || "",
    Experience: data.experience || "",
    lastModified: data.lastModifiedDateTime
        ? new Date(data.lastModifiedDateTime)
        : new Date(),
});

export const mapEmpresaFromBC = (data = {}) => ({
    Primary_Key: data.Primary_Key || "",
    Name: data.Name || "",
    Address: data.Address || "",
    Address_2: data.Address_2 || "",
    City: data.City || "",
    County: data.County || "",
    Post_Code: data.Post_Code || "",
    SAT_Postal_Code: data.SAT_Postal_Code || "",
    Country_Region_Code: data.Country_Region_Code || "",
    Contact_Person: data.Contact_Person || "",
    Phone_No: data.Phone_No || "",
    Phone_No_2: data.Phone_No_2 || "",
    Fax_No: data.Fax_No || "",
    E_Mail: data.E_Mail || "",
    Home_Page: data.Home_Page || "",

    VAT_Registration_No: data.VAT_Registration_No || "",
    Federal_ID_No: data.Federal_ID_No || "",
    EORI_Number: data.EORI_Number || "",
    Industrial_Classification: data.Industrial_Classification || "",
    Registration_No: data.Registration_No || "",

    Bank_Name: data.Bank_Name || "",
    Bank_Branch_No: data.Bank_Branch_No || "",
    Bank_Account_No: data.Bank_Account_No || "",
    Payment_Routing_No: data.Payment_Routing_No || "",
    SWIFT_Code: data.SWIFT_Code || "",
    IBAN: data.IBAN || "",

    Ship_to_Name: data.Ship_to_Name || "",
    Ship_to_Address: data.Ship_to_Address || "",
    Ship_to_Address_2: data.Ship_to_Address_2 || "",
    Ship_to_City: data.Ship_to_City || "",
    Ship_to_County: data.Ship_to_County || "",
    Ship_to_Post_Code: data.Ship_to_Post_Code || "",
    Ship_to_Country_Region_Code: data.Ship_to_Country_Region_Code || "",
    Ship_to_Phone_No: data.Ship_to_Phone_No || "",
    Ship_to_Contact: data.Ship_to_Contact || "",

    Location_Code: data.Location_Code || "",
    Responsibility_Center: data.Responsibility_Center || "",

    Tax_Area_Code: data.Tax_Area_Code || "",
    Tax_Exemption_No: data.Tax_Exemption_No || "",
    Tax_Scheme: data.Tax_Scheme || "",

    RFC_Number: data.RFC_Number || "",
    CURP_No: data.CURP_No || "",
    State_Inscription: data.State_Inscription || "",

    GLN: data.GLN || "",
    Experience: data.Experience || "",

    lastModified: new Date(),
});

// Servicio para sincronizar los datos de la empresa desde Business Central
export const syncEmpresa = async () => {
    if (!isOnline()) {
        return false;
    }

    try {
        console.log("Sincronizando información de empresa...");
        const env = await getCurrentEnvironment();

        // Obtener datos de empresa desde Business Central
        let serverEmpresa;

        if (env.country !== COUNTRY_CODES.HONDURAS && env.country !== COUNTRY_CODES.ELSALVADOR) {
            serverEmpresa = await fetchFromBusinessCentral("Empresa");
        } else {
            serverEmpresa = await fetchFromApiV2("companyInformation");
        }

        if (!serverEmpresa || serverEmpresa.length === 0) {
            console.warn("No se encontraron datos de empresa en Business Central");
            return false;
        }

        //mapeo de datos por pais
        let empresaData;

        if (env.country !== COUNTRY_CODES.HONDURAS) {
            empresaData = mapEmpresaFromBC(serverEmpresa[0]);
        } else {
            empresaData = mapHondurasEmpresa(serverEmpresa[0]);
        }

        await db.empresa.clear();

        await db.empresa.add({
            ...empresaData,
            lastSynced: new Date(),
            lastModified: new Date()
        });

        console.log("Información de empresa creada correctamente");

        return true;
    } catch (error) {
        console.error("Error al sincronizar información de empresa:", error);
        return false;
    }
}; 